import React, {ReactNode} from 'react';
import {IFormFieldConfig, IFormTabFieldConfig} from '@src/@interfaces/components/Form/IFormConfig';

type BaseProps = {
    children: ReactNode,
    displaySign?: boolean,
} & (IFormFieldConfig | IFormTabFieldConfig);

type Props = Pick<Required<BaseProps>, 'children' | 'displaySign'> & Partial<BaseProps> | BaseProps;

export default function RequiredFieldSign(props: Props) {
    let validationRules: any = props.validationRules;
    if (!validationRules && props.displaySign == null) {
        return <>{props.children}</>;
    }

    if (validationRules != null && !Array.isArray(validationRules) && typeof validationRules === 'object') {
        validationRules = Object.keys(validationRules);
    }

    const isRequired = props.displaySign ?? (
            Array.isArray(validationRules) ?
                    validationRules?.includes('required') === true :
                    false
    );
    if (!isRequired) {
        return <>{props.children}</>;
    }

    return <>{props.children} <i className="form-required-field-sign"/></>;
}
